import type { AssistantEntry } from './assistant';
import { FAQ, HELP, KID_HELP } from './content';
import { GENERAL, KID, PUBLIC, TOPICS } from './assistant-questions';

export type AssistantMode = 'auth' | 'public' | 'kid';

/**
 * مدخلاتُ المساعد بحسب من يسأل:
 *   · `auth`: شاشاتُ قائمته (بعنوانها كما يراه) مع دليلها وكلماتها، + الأسئلةُ العامّة، + الأسئلةُ الشائعة.
 *     لا يُجاب أحدٌ عن شاشةٍ لا يملكها — فلا يقال لوليّ الأمر «افتح سجل التدقيق».
 *   · `public`: أبوابُ الدخول والتسجيل والأسئلةُ الشائعة.
 *   · `kid`: أبوابُ منصة الطفل بجملٍ قصيرة.
 */
export function buildEntries(mode: AssistantMode, visible: Array<{ to: string; title: string }> = []): AssistantEntry[] {
  if (mode === 'kid') return [...KID, ...KID_HELP.map((k) => ({ key: `kh:${k.to}`, to: k.to, title: k.title, what: k.text, steps: [] }))];
  const faq: AssistantEntry[] = FAQ.map((f, i) => ({ key: `faq:${i}`, to: null, title: f.q, what: f.a, steps: [], questions: [f.q] }));
  if (mode === 'public') return [...PUBLIC, ...faq];
  const seen = new Set<string>();
  const screens: AssistantEntry[] = [];
  for (const v of visible) {
    const h = HELP[v.to];
    if (!h || seen.has(v.to)) continue;
    seen.add(v.to);
    const t = TOPICS[v.to];
    screens.push({ key: v.to, to: v.to, title: v.title, what: h.what, steps: h.steps, tips: h.tips, keywords: t?.keywords, questions: t?.questions });
  }
  return [...screens, ...GENERAL, ...faq];
}
